// initialed state
export const initialState = () => ({
	issues: [],
	loadingIssues: false,
});

const state = initialState();

export default state;
